export default __webpack_public_path__ + "static/media/October2020.893dda2b.png";